/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_st_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The value that appears most often. A set can have no mode, one mode, or several if multiple values tie for the highest frequency.`)
};

const es_st_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El valor que aparece con más frecuencia. Un conjunto puede no tener moda, tener una, o tener varias si varios valores empatan en la frecuencia más alta.`)
};

const de_st_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der am häufigsten vorkommende Wert. Eine Menge kann keinen, einen oder mehrere Modi haben, wenn sich mehrere Werte die höchste Häufigkeit teilen.`)
};

const nl_st_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De waarde die het vaakst voorkomt. Een reeks kan geen modus, één modus of meerdere modi hebben als meerdere waarden even vaak voorkomen.`)
};

const fr_st_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La valeur qui apparaît le plus souvent. Un ensemble peut n'avoir aucun mode, un seul mode, ou plusieurs si plusieurs valeurs sont à égalité de fréquence maximale.`)
};

const it_st_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il valore che compare più spesso. Un insieme può non avere moda, averne una, o averne diverse se più valori sono a pari merito per la frequenza più alta.`)
};

const pt_br2_st_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O valor que aparece com mais frequência. Um conjunto pode não ter moda, ter uma moda, ou várias se houver empate na maior frequência.`)
};

const pt_st_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O valor que aparece com mais frequência. Um conjunto pode não ter moda, ter uma moda, ou várias se vários valores empatarem na frequência mais alta.`)
};

const ja_st_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最も頻繁に現れる値のことです。データ集合には最頻値がない場合、1つだけの場合、または複数の値が同率で並ぶ場合があります。`)
};

const zh_st_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出现次数最多的数值。一组数据可能没有众数、有一个众数，或者当多个数值出现频率并列最高时有多个众数。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const st_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.st_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("st_faq_a2", locale)
	if (locale === "en") return en_st_faq_a2(inputs)
	if (locale === "es") return es_st_faq_a2(inputs)
	if (locale === "de") return de_st_faq_a2(inputs)
	if (locale === "nl") return nl_st_faq_a2(inputs)
	if (locale === "fr") return fr_st_faq_a2(inputs)
	if (locale === "it") return it_st_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_st_faq_a2(inputs)
	if (locale === "pt") return pt_st_faq_a2(inputs)
	if (locale === "ja") return ja_st_faq_a2(inputs)
	return zh_st_faq_a2(inputs)
};